export function parseMemberUsername(value: string): string | null {
  const normalized = value.trim();
  if (!normalized || normalized.length > 100 || normalized.includes('@')) return null;
  return normalized;
}

export function buildMemberDevicesPath(username: string): string {
  return `/api/admin/member-accounts/by-username/${encodeURIComponent(username)}/devices`;
}

/** Allows only the newest lookup in the current view scope to update UI state. */
export class LatestRequestGuard {
  private epoch = 0;

  begin(): number {
    this.epoch += 1;
    return this.epoch;
  }

  invalidate(): void {
    this.epoch += 1;
  }

  isCurrent(token: number): boolean {
    return token === this.epoch;
  }
}
